<div class="card mt-3">
  <div class="card-header cursor-pointer d-flex align-items-center" [class.bb-0]="!show" (click)="show = !show">
    <i class="icon-stepper-add text-green mr-2"></i>{{ label }}
  </div>
  <div class="card-body" *ngIf="show">
    <pre>{{ entity | json }}</pre>
  </div>
</div>
